import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TextService } from '../../core/services/text-service';

@Component({
  selector: 'product-card',
  templateUrl: './product-card.html',
  styleUrl: './product-card.scss',
  standalone: false
})
export class ProductCard {
  @Input() features: any[] = [];
  textData: any = {};
  productData: any = {};

  constructor(private textService: TextService) {}
  //@Input() showProductFeatures: boolean = false;

  ngOnInit() {
   

  //   this.textService.productData$.subscribe(data => {
  //     console.log('Data??', data);
      
  //     this.productData = data.apps;
  //   });

  //   console.log(this.productData);
    
   }

  toggleFeature(block: any) {
    block.showFeatures = !block.showFeatures;
  }
}
